<template>
  <div
    class="min-vh-100 w-100 d-flex flex-column align-items-center"
  >
    <div
      class="w-100"
    >
      <!-- Topbar -->
      <NavBar />
      <!-- End of Topbar -->
      <div
        style="display: flex; "
        class="main-bottom"
      >
        <SidebarTemplate />
        <div class="homeRight flex-fill">
          <!-- Begin Page Content -->
          <slot />

        <!-- End of Page Content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/common/components/NavBar/NavBar';
import SidebarTemplate from '@/common/components/SidebarTemplate';
// import CommonFooter from '@/components/CommonFooter';

export default {
  components: {
    NavBar,
    SidebarTemplate,
    // CommonFooter,
  },
};
</script>

<style lang="scss" scoped>

.main-bottom{
  height: calc(100vh - 3.125rem) !important;
}
.homeRight {
  position: relative;
  height: inherit !important;
  left : 1.5625rem;
  margin-right: 1.5625rem;
  padding-right: 1.5625rem;
  overflow-y: auto;
}

</style>
